import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Box } from '@mui/material';

interface TermsAndConditionsProps {
  isOpen: boolean;
  popupHandler: (isOpenStatus: boolean) => void;
}

export const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({
  isOpen,
  popupHandler,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => popupHandler(!isOpen)}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>Terms & Conditions</DialogTitle>
      <DialogContent>
        <table className="box-container-layout" style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td colSpan={2} style={{ width: 598 }}>
                <p>
                  <strong>Important Note for UAE Residents</strong>
                </p>
                <p>
                  A valid UAE driving license is a must. Please note that
                  driving without a valid UAE driving license when on residence
                  or employment visa is a violation of the UAE Law.
                </p>
                <p>
                  <strong>N.B. (Please read carefully)</strong>
                </p>
                <p>
                  A. The vehicle image shown is for illustration purpose only.
                  Color and features of the actual vehicle may vary.
                </p>
                <p>
                  B. Thrifty reserves the right to provide a similar vehicle
                  from the same group/category in case the vehicle booked is not
                  available.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Age Restrictions</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  When renting vehicles from Thrifty, the following age limits
                  are observed:
                </p>
                <table style={{ width: 350 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>Minimum</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>21 years old</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>Maximum</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>70 years old</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Concurrent Rentals</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer is not allowed to rent more than 1 vehicle at the
                  same time. If the hirer has an existing active rental that
                  coincides with a new booking’s scheduled pick-up, Thrifty may
                  have the right to refuse the new booking.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ height: 494, verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Required Documents</strong>
                </p>
              </td>
              <td style={{ height: 494, verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer is required to provide the following original, valid
                  documents when renting a vehicle from Thrifty. All documents
                  have to be under the hirer&apos;s name:
                </p>
                <p>
                  <strong>UAE Residents:</strong>
                </p>
                <ul>
                  <li>
                    <p>Original &amp; Valid UAE Driving License.</p>
                  </li>
                  <li>
                    <p>Original &amp; Valid Emirates ID.</p>
                  </li>
                  <li>
                    <p>
                      Credit card (with at least 3 months of validity) for the
                      security deposit. The physical credit card is needed at
                      pick-up/delivery (we can&apos;t complete the booking
                      without it!).
                    </p>
                  </li>
                  <li>
                    <p>
                      A security deposit of AED 1,000 to AED 5,000 (depending on
                      the type of car rented) will be held from your card.
                    </p>
                  </li>
                  <li>
                    <p>
                      Original &amp; valid Passport with a valid residence visa.
                    </p>
                  </li>
                </ul>
                <p>
                  <strong>Non-UAE Residents:</strong>
                </p>
                <ul>
                  <li>
                    <p>
                      International Driving Permit / GCC driving license / valid
                      license from your home country (Check our terms and
                      conditions on our website to find out if your country is
                      exempted)
                    </p>
                  </li>
                  <li>
                    <p>Original Passport with entry stamp</p>
                  </li>
                  <li>
                    <p>
                      Credit card (with at least 3 months of validity) for the
                      security deposit. Physical credit or debit card is needed
                      at pick-up/delivery (we can&apos;t complete the booking
                      without it!)
                    </p>
                  </li>
                  <li>
                    <p>
                      A security deposit of AED 1,000 to AED 5,000 (depending on
                      the type of car rented) will be held from your card.
                    </p>
                  </li>
                </ul>
                <p>
                  <em>* </em>The same credit card can&apos;t be used for more
                  than one rental at the same time<em>.</em>
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ height: 5, verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Security Deposit</strong>
                </p>
              </td>
              <td style={{ height: 5, verticalAlign: 'top', width: 514 }}>
                <p>Thrifty provides two options:</p>
                <p>
                  Option 1 – With Security Deposit: You can choose to pay the
                  Security Deposit either by placing a block on your Credit Card
                  or by making a purchase on your Debit Card.The rental agent
                  shall confirm the amount of security block at the time of
                  vehicle pick-up.
                </p>
                <p>
                  Option 2 - No Security Deposit: This option is exclusively
                  available for UAE Residents applicable only for Monthly
                  Rentals. If you opt for this choice, a non-refundable one time
                  10% surcharge will be applied based on the total rental amount
                  for the first month only.No Security Depositis restricted to
                  certain car groups only. Please note that a Credit Card is
                  mandatory when selecting the No Deposit Monthly Rental.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Driving License Exemptions</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Tourists from all GCC countries and countries listed below are
                  permitted to drive in the UAE with their respective local
                  driving licenses:
                </p>
                <table
                  cellSpacing={0}
                  style={{ borderCollapse: 'collapse', width: 707 }}
                >
                  <tbody>
                    <tr>
                      <td
                        colSpan={5}
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          height: 22,
                          textAlign: 'left',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 705,
                        }}
                      >
                        <strong>List of Exempted Countries</strong>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Albania
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Estonia
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Italy
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Poland
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Spain
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Australia
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Finland
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Japan
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Portugal
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Sweden
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Austria
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        France
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Kuwait
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Qatar
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Switzerland
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Azerbaijan
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Germany/Deutschland
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Latvia
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Romania
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Turkey
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Bahrain
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Greece
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Lithuania
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Saudi Arabia
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Ukraine
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Belgium
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Holland/Netherland
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Luxembourg
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Serbia
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        United Kingdom
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Bulgaria
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Hong Kong
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Malta
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Singapore
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        USA
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Canada
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Hungary
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Montenegro
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Slovakia
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Uzbekistan
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        China
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Iceland
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        New Zealand
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Slovenia
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Croatia
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Cyprus
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Ireland
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Norway
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        South Africa
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 22,
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Denmark
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Israel
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        Oman
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      >
                        South Korea
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          whiteSpace: 'normal',
                          width: 141,
                        }}
                      ></td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  International or Local Driving license in any other language
                  other than Arabic and English should be translated into Arabic
                  or English. The translation should be attested by the Embassy.
                </p>
                <p>
                  Please note that in case the hirer’s Visit or Tourist visa in
                  UAE is changed to a Residence visa, you will need to obtain an
                  UAE driving license. This together with a copy of your
                  passport with Residence visa page has to be submitted to
                  Thrifty Immediately.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ width: 598 }}>
                <p>
                  <strong>Booking and Rental</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Minimum Rental Period and Increments</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The minimum rental period is 1 day (24 hours). Prorated hourly
                  rental is not allowed.
                </p>
                <p>
                  A rental with less than 24-hour duration will be considered as
                  a 1-day rental. Similarly, any excess rental period that is
                  less than 24 hours is considered as an additional 1-day
                  rental.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Types of Short-Term Rental Based on Duration</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Bookings/rentals are categorized based on the duration of the
                  rental.
                </p>
                <table style={{ width: 350 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          <strong>Duration</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          <strong>Type</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>1-6 Days</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>Daily</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>7-21 Days</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>Weekly</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>22 Days or more</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>Monthly</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Making ABooking</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer may reserve their booking via the following options:
                </p>
                <ul>
                  <li>Creating a booking online via Thrifty UAE website</li>
                  <li>Getting in touch with the contact centre</li>
                  <li>Visiting any Thrifty rental desk</li>
                </ul>
                <p>
                  The hirer should then present the corresponding
                  electronic/paper voucher at Thrifty Car rental counter if
                  booking was made through the website.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Booking Modification</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer may modify their prepaid booking online if done at
                  least 24 hours prior to pick-up date and time, and will be
                  charged with the corresponding fee(s). The total payable
                  amount will be recalculated if the rates have changed between
                  the dates the original and amended bookings are made. In which
                  case, the latter prices will apply.
                </p>
                <table style={{ width: 474 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 219,
                        }}
                      >
                        <p>
                          <strong>Modification is Allowed For</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 255,
                        }}
                      >
                        <p>
                          <strong>Modification is Not Allowed For</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 219,
                        }}
                      >
                        <p>Primary hirer’s name</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 255,
                        }}
                      >
                        <p>Credit card details</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 219,
                        }}
                      >
                        <p>Vehicle group</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 255,
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 219,
                        }}
                      >
                        <p>Pick-up/Drop-off location</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 255,
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 219,
                        }}
                      >
                        <p>Pick-up/Drop-off date and/or time</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 255,
                        }}
                      ></td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  If the hirer needs to change the primary name and/or credit
                  card details, they need to cancel the existing booking (see
                  Booking Cancellation under Booking and Rental) and make a new
                  one with the correct details.
                </p>
                <table style={{ width: 473 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          <strong>Prepaid Booking Modification Type</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 107,
                        }}
                      >
                        <p>
                          <strong>Fee</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          Hirer modifies booking 24 hours (or more) prior to
                          pick-up date and time
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 107,
                        }}
                      >
                        <p>NIL</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          Hirer modifies booking less than 24 hours prior to
                          pick-up date and time
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 107,
                        }}
                      >
                        <p>AED 52.50</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Booking Cancellation</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer may cancel their prepaid booking online and will be
                  charged with the corresponding fee(s).Refunds, where
                  applicable, will be made to the credit card used on the
                  original prepaid booking within 30 calendar days.
                </p>
                <table style={{ width: 473 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          <strong>Prepaid Booking Cancellation Type</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 106,
                        }}
                      >
                        <p>
                          <strong>Fee</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          Hirer cancels booking 24 hours (or more) prior to
                          pick-up date and time
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 106,
                        }}
                      >
                        <p>NIL</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          Hirer cancels booking less than 24 hours prior to
                          pick-up date and time
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 106,
                        }}
                      >
                        <p>AED 105.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                        }}
                      >
                        <p>
                          Cancellation due to unavailability of hirer’s
                          documents, or non-conformance to document requirements
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 106,
                        }}
                      >
                        <p>AED 105.00</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>No Show</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  AED 100 fee will be charged if the customer fails to show up
                  for a prepaid booking that has not been cancelled prior to the
                  pick-up schedule.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Late Arrival</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  If a client makes a prepaid booking but fails to arrive at the
                  specified pick-up location within 2 working hours of the
                  pick-up schedule (or if the location closes before then, by
                  the location’s closing time), the vehicle may still be
                  provided subject to availability. The pick-up and drop-off
                  timings per the voucher will be adhered to.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Rental Extension</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  For rentals booked in the Thrifty UAE website, the hirer may
                  extend their active rental by creating a new booking with
                  pick-up date and time matching their current rental’s off-hire
                  date and time. The website rates at the time of new booking
                  shall apply on the rental extension.
                </p>
                <p>
                  If the hirer fails to do so, they may request for the rental
                  extension at any Thrifty rental desk, and the local rates and
                  policies will apply on the rental extension.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Early Return</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  There will be no refund for unused car rental days once a
                  Daily or Weekly rental has started.
                </p>
                <p>
                  Fixed monthly rate will apply for hire periods between 22-30
                  days; pro-rata is not applicable. Early car return will
                  automatically cancel the monthly plan, and the corresponding
                  weekly or daily charge will apply.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Late Return</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Only 1-hour grace period for late return is allowed. Beyond
                  this, rental charges will apply per local rates and policies.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ width: 598 }}>
                <p>
                  <strong>Payment and Fees</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Value-Added Tax (Vat)</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Effective January 2018, Thrifty Car Rental reserves the right
                  to add value-added tax (VAT) on all services and rates, as
                  confirmed and implemented by the UAE Government. This is
                  applicable on all bookings for pick-up from 01-Jan-2018.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Rates Validity</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Thrifty Car Rental reserves the right to change the prices of
                  its products and services.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Payment</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  All prices are payable in UAE Dirhams (AED). Cash and all
                  major credit cards are accepted as means of payment. Advance
                  payment for the whole rental is required prior to collecting
                  the vehicle from the counter. For bookings made on the Thrifty
                  UAE website, the credit card used online must be presented at
                  the time of pick up.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Vehicle Registration Fee (VRF)</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Vehicle Registration Fee (VRF) charges apply on all rentals.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>One-Way Rental Fee (OWR)</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  If the hirer returns the rented vehicle to any Thrifty
                  location other than the original pick-up location, One-Way
                  Rental fees (OWR) shall apply.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Airport Fee (PRK)</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  If the hirer picks up and/or drops off the vehicle at any
                  airport location, Airport Fees (PRK) shall apply.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Toll Fee</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Toll gate crossing (Salik &amp; DARB) is charged at [actual
                  price + 25% administration fee] + VAT.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Traffic Fines</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Any traffic fine incurred by the hirer is their liability and
                  is charged at actual fine amount + (10% administration fee +
                  VAT).
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Impounding Fee</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  If the vehicle is impounded, the customer is liable to
                  compensate Thrifty for both the impounding feeandloss of
                  rental.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Parking Fee</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer is responsible for registering their vehicle for
                  paid parking and for all parking charges in relation to the
                  vehicle whilst on hire.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Fuel Policy</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer is required to return the vehicle with the same fuel
                  level that it has when it was hired. Otherwise, a
                  locally-determined refuelling charge will apply.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Abu Dhabi Accident Report</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Abu Dhabi traffic department/police charges an additional fee
                  for accident reports which is to be paid by renter. These
                  charges are over and above the Insurance Excess charge.
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ width: 598 }}>
                <p>
                  <strong>Insurance and Protection</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Personal Accident Insurance</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer may purchase the Personal Accident Insurance (PAI)
                  for added security for the vehicle occupants. This provides
                  for compensation in the unfortunate event of an accident
                  involving the rented vehicle that results to physical injury
                  or death of the occupant(s). Note that PAI does not cover
                  hospitalizations.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Additional Insurance/ Protection Options</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer may purchase additional vehicle insurance for their
                  rental to reduce their financial liability for damage to the
                  Thrifty vehicle, its parts and accessories, provided the
                  vehicle is used in accordance with the terms and conditions of
                  the hire agreement.
                </p>
                <ul>
                  <li>Super Collision Damage Waiver (SCDW)</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Insurance Excess</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  In the event of an accident involving the rented vehicle that
                  results in vehicle damage, the payable insurance excess is
                  based on the result of the police report and type of
                  additional vehicle insurance availed by the hirer at the time
                  of booking or hiring the vehicle.
                </p>
                <p>Things to Remember:</p>
                <ul>
                  <li>
                    Basic Insurance (IXS) is already included in the basic
                    rental rate.
                  </li>
                  <li>
                    The hirer’s driving license should be at least 6 months old
                    in order to avail the SCDW.
                  </li>
                  <li>
                    The hirer is responsible in obtaining the corresponding
                    police report for any vehicle damage. Full repair fees will
                    be charged to the client in the absence of police report.
                  </li>
                  <li>Personal belongings or luggage are not insured.</li>
                  <li>
                    Thrifty is not responsible for any personal
                    belongings/luggage left inside the vehicle upon off-hire.
                  </li>
                </ul>
                <table style={{ width: 482 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          height: 19,
                          width: 319,
                        }}
                      >
                        <p>
                          <strong>Type of vehicle insurance</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          height: 19,
                          width: 158,
                        }}
                      >
                        <p>
                          <strong>Hirer at fault</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          height: 19,
                          width: 154,
                        }}
                      >
                        <p>
                          <strong>Hit-and-run*</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          height: 19,
                          width: 141,
                        }}
                      >
                        <p>
                          <strong>Hirer not at fault</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          width: 319,
                        }}
                      >
                        <p>
                          <strong>Basic insurance</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          verticalAlign: 'bottom',
                        }}
                      ></td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          verticalAlign: 'bottom',
                        }}
                      ></td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          verticalAlign: 'bottom',
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 38,
                          width: 319,
                        }}
                      >
                        <p>
                          If no added insurance is purchased, the hirer will be
                          charged with the full Insurance Excess (IXS).
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 38,
                          verticalAlign: 'top',
                          width: 158,
                        }}
                      >
                        <p>Full amount of insurance excess to be paid</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 38,
                          verticalAlign: 'top',
                          width: 154,
                        }}
                      >
                        <p>Full amount of insurance excess to be paid</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 38,
                          width: 141,
                        }}
                      >
                        <p>n/a</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          verticalAlign: 'top',
                          width: 319,
                        }}
                      ></td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          verticalAlign: 'top',
                          width: 158,
                        }}
                      ></td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          verticalAlign: 'top',
                          width: 154,
                        }}
                      ></td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: 'none',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          verticalAlign: 'top',
                          width: 141,
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          width: 319,
                        }}
                      >
                        <p>
                          <strong>Super Collision Damage Waiver (SCDW)</strong>
                        </p>
                      </td>
                      <td
                        rowSpan={2}
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          width: 158,
                        }}
                      >
                        <p>n/a</p>
                      </td>
                      <td
                        rowSpan={2}
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          width: 154,
                        }}
                      >
                        <p>n/a</p>
                      </td>
                      <td
                        rowSpan={2}
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          width: 141,
                        }}
                      >
                        <p>n/a</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: 'none',
                          height: 19,
                          width: 319,
                        }}
                      >
                        <p>
                          On purchasing SCDW, the insurance excess liability is
                          waived.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  <em>
                    *“Hit-and-run” refers to accidents wherein the fault cannot
                    be attributed to a third party.
                  </em>
                </p>
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ width: 598 }}>
                <p>
                  <strong>On the Road</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Driving Restrictions</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  The hirer is prohibited to use the vehicle under below
                  conditions and activities:
                </p>
                <ul>
                  <li>
                    When the hirer is under the influence of alcohol/drugs
                  </li>
                  <li>Racing, towing other vehicles, or off-road driving</li>
                  <li>Any other activity considered against the UAE law</li>
                </ul>
                <p>
                  The vehicle insurance does not cover any accident/damage
                  resulting from any of the above scenarios. Any such violation
                  would make the hirer liable to pay for the total damages to
                  the vehicle and/or any ancillary damages caused.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>KilometresLimits </strong>
                </p>
                <p>
                  <strong>(Dubai &amp; Northern Emirates)</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>Daily and Weekly Rentals:</p>
                <p>
                  Unlimited Kilometres is applicable on daily &amp; weekly
                  rentals except for the vehicles listed below.
                </p>
                <ul>
                  <li>
                    BMW 520(350KM per day; 2,100KM per week), AED1.00 per excess
                    KM charge
                  </li>
                  <li>
                    BMW 730Li(350KM per day; 2,100KM per week),AED1.00 per
                    excess KM charge
                  </li>
                </ul>
                <p>
                  <strong>Monthly Rentals:</strong>
                </p>
                <p>
                  All monthly rentals (22 days and above) are subject to
                  Kilometres limits and extra Kilometres charges (EMC).
                </p>
                <table style={{ width: 481 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>
                          <strong>MODEL</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>
                          <strong>Kilometres limit(per month)</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>
                          <strong>Extra kilometres charge (in AED)</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Kia Picanto</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Micra</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Sunny</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Yaris Sedan</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>MG 5</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mitsubishi Attrage</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Hyundai Accent</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Hyundai Creta</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Kicks</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Rush</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Hyundai Tucson</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>MG ZS</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Corolla Cross</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Hyundai Elantra</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Corolla</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mazda 3</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Altima</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Camry</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mazda 6</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.25</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mercedez C200</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Dodge Charger</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Volvo S90</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>BMW 5 Series</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>BMW 7 Series</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mazda CX5</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan X-Trail</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Fortuner</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mazda CX9</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Jeep Wrangler</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Dodge Challenger</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Kia Carnival</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Ford Explorer</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>VW Teramont</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Hyundai Pallisade</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Kia Telluride</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Dodge Ram</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Chevrolet Tahoe</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Patrol</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Volvo XC 90</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 161,
                        }}
                      >
                        <p>2500 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 169,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Kilometres Limits </strong>
                </p>
                <p>
                  <strong>(Abu Dhabi)</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>Daily and Weekly Rentals (Abu Dhabi locations):</p>
                <p>
                  Unlimited Kilometres is applicable on daily &amp; weekly
                  rentals for all vehicles except the ones listed below.
                </p>
                <ul>
                  <li>BMW 520 (250KM per day; 1,500KM per week)</li>
                  <li>BMW 730Li(350KM per day; 2,100KM per week)</li>
                  <li>Dodge Charger 3.6L (350KM per day; 2,100KM per week)</li>
                  <li>Audi A6(350KM per day; 2,100KM per week)</li>
                  <li>Polestar 2 (200KM per day; 1,750KM per week)</li>
                  <li>Mercedes C Class(350KM per day; 2,100KM per week)</li>
                </ul>
                <p>Daily and Weekly Rentals (Al Ain and Ruwais locations):</p>
                <p>
                  All daily and weekly rentals are subject to Kilometres limits
                  and extra Kilometres charges (EMC).
                </p>
                <ul>
                  <li>Daily: 350 KM per day</li>
                  <li>Weekly: 1,750 KM per week</li>
                </ul>
                <p>
                  <strong>Monthly Rentals</strong> (Abu Dhabi, Al Ain &amp;
                  Ruwais locations):
                </p>
                <p>
                  All monthly rentals are subject to Kilometres limits and extra
                  Kilometres charges (EMC).
                </p>
                <table style={{ width: 472 }}>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>
                          <strong>Model</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>
                          <strong>Kilometres limit (per month)</strong>
                        </p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>
                          <strong>Extra kilometres charge (in AED)</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Chevrolet Spark</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Sunny</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Yaris Sedan</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Hyundai Accent</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>MG- 5</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Kicks</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Hyundai Creta</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>MG- ZS</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Corolla Cross</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Rush</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Hyundai Tucson</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Corolla</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mazda 3</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Altima</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Camry</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mazda 6</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Dodge Charger</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>BMW 5 Series</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>BMW 7 Series</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan X-Trail</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mazda CX-5</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Prado</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Toyota Fortuner</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Pathfinder</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mazda CX-9</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>VW Teramont</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Ford Explorer</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Mercedez C200</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Audi A6</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>1.00</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>VW Golf GTI</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Peugeot-3008</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.35</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>Nissan Patrol</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 170,
                        }}
                      >
                        <p>3000 KM</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          width: 151,
                        }}
                      >
                        <p>0.50</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Roadside Assistance</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  For any breakdown or roadside issue, the hirer may contact our
                  customer care team.
                </p>
                <table style={{ width: 472 }}>
                  <tbody>
                    <tr>
                      <td
                        colSpan={2}
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 472,
                        }}
                      >
                        <p>
                          <strong>Customer Care Hotlines</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 350,
                        }}
                      >
                        <p>Dubai, Sharjah, Ajman, Ras al Khaimah, Fujairah</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 122,
                        }}
                      >
                        <p>800 4770</p>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 350,
                        }}
                      >
                        <p>Abu Dhabi &amp; Al Ain</p>
                      </td>
                      <td
                        style={{
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          verticalAlign: 'top',
                          width: 122,
                        }}
                      >
                        <p>800 701</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ width: 598 }}>
                <p>
                  <strong>Value-Added Services</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Delivery and Collection</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Delivery and collection services may be provided upon request,
                  and will be charged accordingly.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Additional Driver</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  A second driver may be added at an extra cost. In addition to
                  the main hirer’s documents, they shall also provide the
                  passport copy and driving license of the second driver.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Child Seat</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Child seats for age bracket of 1-4 years old are available on
                  request at an extra cost, and are subject to availability.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Oman Insurance</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>
                  Oman insurance and NOC can be provided by Thrifty Car Rental
                  on certain car groups at an additional cost.
                </p>
                <p>
                  Once you have entered Oman, in case of any breakdown,
                  mechanical failure or accident it is the hirer’s
                  responsibility to have the car brought or recovered to the
                  border at their own cost, for any replacement or further
                  recovery.
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ verticalAlign: 'top', width: 81 }}>
                <p>
                  <strong>Chauffeur Service</strong>
                </p>
              </td>
              <td style={{ verticalAlign: 'top', width: 514 }}>
                <p>(currently not available)</p>
              </td>
            </tr>
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
};
